// Wall-of-Trust testimonial data.
// Real WhatsApp screenshots, outcome-focused titles, service tags.
// Order: featured first, then 5 grid items.

export const FEATURED_TESTIMONIAL = {
  id: 'featured',
  tag: 'Business Growth',
  title: 'Helping a Family-Owned Business Start the Right Way',
  context:
    'A new founder building a business she hopes her daughters can one day take over. Eureka1 stepped in early to set the right operational foundations — and the gratitude that followed says it all.',
  quote:
    'I don\u2019t have enough "Thank You\u2019s" to give to you. You know I have two daughters and I want to start a family business that they can take over and operate if they want. To just be able to show them how to be an entrepreneur would be an accomplishment I would be proud of as well. So I Thank You for helping me get this started the right way.',
  image:
    'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/als8ua0p_image.png',
};

export const TESTIMONIALS = [
  {
    id: 't1',
    tag: 'Operations Support',
    title: 'Trusted Operational Partner',
    summary:
      'After looking for dependable help "from a long time ago," this client now has someone who takes care of customers and the day-to-day so the team can focus on the work.',
    image:
      'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/vh342znm_Screenshot_20260622_103119_WhatsAppBusiness.jpg',
  },
  {
    id: 't2',
    tag: 'Business Growth',
    title: 'Building Systems That Support Growth',
    summary:
      '"Be ready for the pressure" — a client preparing to scale with the operational foundations in place to handle it. Confidence rooted in structure, not guesswork.',
    image:
      'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/bl7mdtzf_Screenshot_20260622_103249_WhatsAppBusiness.jpg',
  },
  {
    id: 't3',
    tag: 'Website Development',
    title: 'Website Approved & Ready to Launch',
    summary:
      '"I love the website." A completed website project signed off — and the down payment transferred — with confidence in the quality of the work delivered.',
    image:
      'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/7lv5htqm_Screenshot_20260622_103325_WhatsAppBusiness.jpg',
  },
  {
    id: 't4',
    tag: 'Customer Experience',
    title: 'Hallie for the Win',
    summary:
      '"This is EXACTLY what I\u2019ve been expecting from this guy. Hallie it looks perfecttttttt." A document delivered, expectations met, and the win celebrated together.',
    image:
      'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/qqelrls8_image.png',
  },
];

// Qualitative business outcomes (kept).
export const BEFORE_AFTER = [
  { id: 'ba1', metric: 'Customer communication', before: 'Inconsistent, slow follow-up', after: 'Clear, prompt, reliable replies' },
  { id: 'ba2', metric: 'Scheduling', before: 'Scattered across tools', after: 'Streamlined, single source of truth' },
  { id: 'ba3', metric: 'CRM & follow-up', before: 'Manual reminders, gaps', after: 'Documented workflows, less missed' },
  { id: 'ba4', metric: 'Owner workload', before: 'Constant supervision required', after: 'Team owns the day-to-day' },
];

// Legacy export — same screenshots, used by /home section.
export const SCREENSHOT_GALLERY = TESTIMONIALS.map((t) => ({
  id: t.id,
  title: t.title,
  caption: t.summary,
  image: t.image,
}));
